import React, { Fragment, useContext } from 'react';
import { Container, Col } from 'react-bootstrap';
import MainFooter from '../nav/MainFooter';
import TopNav from '../nav/TopNav';
import ApparelNav from './ApparelNav';
import PropTypes from 'prop-types';
import ApparelContext from '../../context/apparel/apparelContext';
import TeesItem from './TeesItem';

const ApparelTees = ({ icon }) => {
  const apparelContext = useContext(ApparelContext);

  // destructuring the ApparelContext
  const { tees } = apparelContext;

  return (
    <Fragment>
      <Container fluid className='ApparelCollections'>
        <TopNav />
        <Container>
          <ApparelNav />
          <div className='ApparelCollections-filter'>
            <div className='ApparelCollections-filter_content text-light'>
              <div>Filter by:</div>
              <button className='text-capitalize btn btn-black'>men</button>
              <button className='text-uppercase btn btn-black'>xs</button>
            </div>
            <div className='ApparelCollections-filter_recom text-light'>
              <div>Sort by:</div>
              <div>
                Recommended <i className={icon} aria-hidden='true'></i>
              </div>
            </div>
          </div>
          <div className='tees_items'>
            {tees.map((tee) => (
              <TeesItem key={tee.id} tee={tee} />
            ))}
          </div>
          <Col md={{ span: 4, offset: 5 }} className='mb-4'>
            <button className='btn btn-black'>lode more</button>
          </Col>
        </Container>
      </Container>
      <MainFooter />
    </Fragment>
  );
};

ApparelTees.defaultProps = {
  icon: 'fa fa-chevron-down',
};

ApparelTees.propTypes = {
  icon: PropTypes.string.isRequired,
};
export default ApparelTees;
